<template>
    <div class="w100 d-address-wrapper">
        <!-- <h2>Choose Delivery Address</h2> -->
        <span @click="addNewAddress()" class="pointer add-new-address"><v-icon >add</v-icon>Add New Address</span>
        <div class="cart-wrapper w100">
            <form class="w100" v-if="addressBit">
                <div class="w100">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="address" label="Ho.no./Floor/Street" :rules="[() => !!address || 'This field is required']" :error-messages="errorMessages" outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">

                            <v-text-field v-model="locality" label="Landmark / Locality" outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="pincode" :rules="[() => !!pincode|| 'This field is required']" :error-messages="errorMessages" label="PIN Code" outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="city" :rules="[() => !!city || 'This field is required']" :error-messages="errorMessages" label="City Name" outlined clearable></v-text-field>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="4">
                            <v-radio-group v-model="row" outlined clearable row>
                                <span class="pr-3">Address Type</span>
                                <v-radio label="Home" name="address_type"></v-radio>
                                <v-radio label="Office" name="address_type"></v-radio>
                                <v-radio label="Other" name="address_type"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </div>
     
						<div class="col-lg-12 auto mt-1 pad-15 mb-3">
										<input type="submit" id='submitBtn' class=" submit-btn" value="Submit" @click="saveAddress()">&nbsp;
										<input type="reset" class="cancel-btn" value="Cancel" @click="clear">
									</div>
            </form>
               <div class="pad-15 w100 mb-5 bod">
                <div class="exist-add">
                    <input type="radio" name="deliver_address" @click="onChange(0)" v-model="address_id" value="0" id="pickup" checked="checked" class="with-gap validate[required],gender" required>
                    <label for="pickup"> <span class="c_add_nm"> Order PickUp</span>
                    </label>
                </div>
            </div>

            <div class="pad-15 w100 mb-5 bod" v-for="address in addressList" :key="address.address_id">
                <div class="exist-add"><a href="#" class="edit-address">Edit</a>

                    <input type="radio" name="deliver_address" @click="onChange(address.address_id)" v-model="address_id" :value="address.address_id" :id="'h'+address.address_id" class="with-gap validate[required],gender" required>
                    <label :for="'h'+address.address_id"> <span class="c_add_nm">{{address.name}}</span>
                        &nbsp;<span class="add-type">{{address.address_type}}</span>
                        <span class="f-add">+91 - {{mobile}}<br>{{address.address}},{{address.locality}},{{address.city}} ({{address.pincode}})</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import ApiList from '../ApiList'
import GlobalMixin from '../globalMixins'
// import DashBoardLayout from '../../layouts/DashboardLayout.vue'
export default {
    // props: ['addressList', 'addressBit'],
    mixins: [ApiList, GlobalMixin],
    components: {
        // DashBoardLayout
    },
    data() {
        return {
            customer_id: '-1',
            addressList: [],
            addressBit: false, // used to show add_new_address form
            city: '',
            pincode: '',
            locality: '',
            address: '',
            address_type: '',
            delivery_address: 0,
            payment_mode: 'COD',
            error_show: false,
            selecetdAddress: '',
            address_id: '',
            errorMessages: '',
            mobile : '',
        }
    },
    mounted() {
        this.loadAddress()
    },
    methods: {
        addNewAddress() {
            this.addressBit = true
            // alert(this.addressBit)
        },
        submit() {
            this.$v.$touch()
            this.saveAddress()
        },
        clear() {
            this.$v.$reset()
            this.name = ''
            this.mobile_no = ''
            this.select = null

        },
        onChange(a) {
            this.address_id = a
            console.log("address"+this.address_id)
            this.$emit('onChange', this.address_id)
        },
        loadAddress: function () {
            this.customer_id = localStorage.getItem("customer_id");
            this.mobile = localStorage.getItem("tmp_mobile")
            var addressURL = this.apis.apiUrl + this.apis.addressUrl + "?token=" + localStorage.token + "&customer_id="+localStorage.customer_id
            console.log("address url : " + addressURL)
            axios.get(addressURL)
                .then((response) => {
                    // alert(response)
                    this.addressList = response.data;
                    if (this.addressList.length == 0) {
                        this.addFlag = true
                    } else {
                        this.addFlag = false
                    }
                    this.addressmobile = localStorage.mobile;
                    console.log("cust id =" + this.customer_id);
                    console.log(this.addressList);
                    this.selecetdAddress = this.addressList[0].address_id
                });

        },
        saveAddress: function () {
            this.addressBit = false
            var AddressURL = this.apis.apiUrl + this.apis.saveAddressUrl + "?token=" + localStorage.token + "&customer_id=" + localStorage.customer_id
            //alert(this.saveAddressUrl)

            axios.get(AddressURL, {
                    params: {
                        address: this.address,
                        locality: this.locality,
                        pincode: this.pincode,
                        city: this.city,
                        address_type: this.address_type,
                        customer_id: this.customer_id
                    }
                })
                .then(res => {
                    console.log(res);
                    alert(res.data)
                    this.loadAddress()
                })
                .catch(console.log("ERROR ADDING TO FAVORITES"))

        },

    },
}
</script>

<style>

.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
    padding: 5px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0 !important
}

</style>
